var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.596 58.345",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "24.41 40.051 33.399 40.051 37.848 25.958 28.885 10.798 20.039 26.27 24.41 40.051"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "12.16 40.051 23.361 40.051 19.364 27.451 12.16 40.051"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.179 40.051 38.531 27.114 34.448 40.051 46.179 40.051"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.628 24.975 28.159 10.054 13.116 4.446 19.628 24.975"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.881,3.832l-6.945,22,8.334,14.1c4.327-5.638,7.7-12.437,7.7-19.946C54.97,12.626,51.19,6.34,45.881,3.832Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "24.727 41.051 28.916 54.255 33.084 41.051 24.727 41.051"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "44.594 4.586 29.622 10.077 38.252 24.677 44.594 4.586"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.787,2.657c-4.189,0-8.2,2.319-10.883,6.251l15-5.5A11.771,11.771,0,0,0,40.787,2.657Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.428,55.951a74.313,74.313,0,0,0,16.964-14.9H34.132Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.892,3.9c-5.235,2.552-8.948,8.8-8.948,16.091,0,7.229,3.617,14.1,8.164,19.889l7.845-13.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.055,41.051a85.142,85.142,0,0,0,16.31,14.776L23.678,41.051Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.127,2.657a11.75,11.75,0,0,0-4.018.719L28.033,8.94C25.323,4.935,21.392,2.657,17.127,2.657Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.97,19.986c0-10.107-6.811-18.329-15.183-18.329-4.587,0-8.958,2.552-11.829,6.866-2.874-4.315-7.245-6.866-11.831-6.866a12.825,12.825,0,0,0-5.381,1.21l-.2-.076.046.146C5.95,5.616,1.944,12.24,1.944,19.986c0,7.773,4.034,15.066,8.617,20.845l-.126.22h.3a67.658,67.658,0,0,0,4.609,5.17A87.369,87.369,0,0,0,28.688,57.25l.161.1.069.217.053-.17.239-.138a74.834,74.834,0,0,0,18.445-16.21h.276l-.12-.2C52.368,35,55.97,27.885,55.97,19.986ZM40.787,2.657a11.771,11.771,0,0,1,4.118.75l-15,5.5C32.589,4.976,36.6,2.657,40.787,2.657Zm3.807,1.929L38.252,24.677l-8.63-14.6ZM38.531,27.114l7.648,12.937H34.448Zm-.683-1.156L33.4,40.051H24.41L20.039,26.27,28.885,10.8ZM23.361,40.051H12.16l7.2-12.6ZM19.628,24.975,13.116,4.446l15.043,5.608Zm-2.5-22.318c4.265,0,8.2,2.278,10.906,6.283L13.109,3.376A11.75,11.75,0,0,1,17.127,2.657ZM2.944,19.986c0-7.295,3.713-13.539,8.948-16.091l7.061,22.26-7.845,13.72C6.561,34.085,2.944,27.215,2.944,19.986Zm9.111,21.065H23.678l4.687,14.776A85.142,85.142,0,0,1,12.055,41.051Zm16.861,13.2-4.189-13.2h8.357Zm.512,1.7,4.7-14.9h12.26A74.313,74.313,0,0,1,29.428,55.951ZM47.27,39.932l-8.334-14.1,6.945-22C51.19,6.34,54.97,12.626,54.97,19.986,54.97,27.5,51.6,34.294,47.27,39.932Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.513e53dfc59a9f165a89d442271756fb.svg";
export { ForwardRef as ReactComponent };